import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { SpEditorModule } from '@components/sp-editor';

import { SpCommonEditorComponent } from './sp-editor-common.component';

@NgModule({
    imports: [CommonModule, SpEditorModule, SpCommonEditorComponent],
    exports: [SpEditorModule, SpCommonEditorComponent],
    declarations: [],
})
export class SpCommonEditorModule {}
